export const moveByCopy = {
  months_0_3: "0 to 3 months",
  months_3_6: "3 to 6 months",
  months_6_12: "6 to 12 months",
  months_12: "12+ months"
};

export const searchTypeCopy = {
  rent: "rent",
  buy: "buy",
  sell: "sell",
  buy_sell: "buy + sell",
  browse: "browse"
};
